export enum CountryId {
  Maldives = 56,
  Russia = 76,
  Abkhazia = 1,
  Turkey = 92,
  Tunisia = 91,
  Uae = 68,
}
